import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex flex-col items-center justify-center min-h-[70vh] text-center px-4 py-16">
      <h1 className="text-7xl md:text-[10rem] font-heading font-black text-background-200 select-none pointer-events-none">
        404
      </h1>
      <div className="relative z-10 -mt-4 md:-mt-8">
        <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground-50">
          页面不存在或已调整
        </h2>
        <p className="mt-3 text-sm text-foreground-500 font-mono">{location.pathname}</p>
        <p className="mt-4 text-sm md:text-base text-foreground-400 max-w-md">
          你访问的页面可能已被移动或删除。可以返回首页，或前往影视分类继续浏览内容。
        </p>
        <div className="flex flex-wrap items-center justify-center gap-3 mt-6">
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-5 h-10 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium whitespace-nowrap transition-colors"
          >
            <i className="ri-home-5-line" />
            返回首页
          </Link>
          <Link
            to="/category"
            className="inline-flex items-center gap-2 px-5 h-10 rounded-md border border-background-300/60 text-foreground-200 text-sm whitespace-nowrap transition-colors"
          >
            <i className="ri-layout-grid-line" />
            前往分类
          </Link>
        </div>
      </div>
    </div>
  );
}